import { message } from 'ant-design-vue'
import { portal_user_hasAccess_get } from 'server/modules/732.js'
export default {
  state: {
    hasSimulate: false
  },
  mutations: {
    async GET_HAS_SIMULATE(state) {
      const token = localStorage.getItem('token')
      if (!token) return
      const { success, retInfo, data } = await portal_user_hasAccess_get({})
      if (success) {
        state.hasSimulate = data
      } else {
        message.error(retInfo)
      }
    }
  },
  actions: {}
}
